import React from "react"
import badge from "badges/special-badge-blocked.svg"
import { BadgeImage } from "backpack/badges/styled"

const SpecialBadgeBlocked = props => <BadgeImage src={badge} {...props} />

export default SpecialBadgeBlocked
